/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export const ActionTypes = {
    NamedProps: {} ,
    TITLES_REQUEST: "TITLES_REQUEST",
    TITLES_UPDATE: "TITLES_UPDATE",
    SELECTED_FLIWAS_PERMISSION_NAMESPACE: "SELECTED_FLIWAS_PERMISSION_NAMESPACE"
};


export const ClassNames = keyMirror({
    GroupSchema: null,
    ReferenceValue: null,
    AssetCategory: null,
    NamedProp: null,
    DLFileEntry: null,
    AssetLink: null,
    AssetTag: null,
    GeoFeature: null,
    User: null,
    Team: null,
    Group: null,
    FliwasPermission: null
});

export const JournalTypeNames = keyMirror({
    Webcam: null,
});


export const GROUP_NAMED_LISTS = 'groupNamedLists';


export const ElementTypes = keyMirror({
    StatusBox: null,
    PropertyBox: null,
    StatusPropertyBox: null,
    DynamicContentBox: null
});

export const STORE_KEY_GROUP_SCHEMAS = 'groupSchemas';

export const EVENT_TYPE_CREATE = 'CREATE';
export const EVENT_TYPE_DELETE = 'DELETE';
export const EVENT_TYPE_UPDATE = 'UPDATE';

export const UNITS = {
    CM: 'cm',
    CBMS: 'm³/s',
    CBM: 'm³',
    PERCENT: '%',
    MM: 'mm',
    MM_5MIN: 'mm/5 min',
}





// WEBPACK FOOTER //
// ./js/constants/Constants.js